var lib_core = require("lib-core");
var editor_2d = require("editor-2d");
var cio_datamodel = require("cio-datamodel");

var PropertyInteractionView = require("./../propertyViewer/propertyInteractionView.js");

var ShapeWrapperInteractionView = function (editorView, interactionModel, parentGroup, layers) {
    var self = this;

    this.editorView = editorView;
    this.gui = this.editorView;
    this.interactionModel = interactionModel;
    this.parentGroup = parentGroup;
    this.layers = layers;
    this.editorModel = editorView.editorModel;

    this.data = interactionModel.data;

    if(this.data.shape()) this.buildShapeView();
    this.data.shape.onChange(this, function (value, old) {
        if(value) self.buildShapeView();
    });

    this.data.layerIndex.onBubble(this, function (value) {
        if(self.data.shape()) self.buildShapeView();
    });

    this.editorModel.visibleLayers.onBubble(this, function (value) {
        if(self.data.shape()) self.buildShapeView();
    });

    this.data.onBubble(this, function () {
        if(this.shapeInteractionView) {
            self.editorView.heavyHandler.scheduleHeavy('rebuild_view', self.shapeInteractionView.draw, self.shapeInteractionView, [], self);
        }
    });
};

module.exports = ShapeWrapperInteractionView;

ShapeWrapperInteractionView.prototype.getLayers = function () {
    return this.layers;
};

ShapeWrapperInteractionView.prototype.buildShapeView = function () {
    var self = this;

    this.removeSvg();
    if(!this.interactionModel.isAlive()) return;
    if(!this.interactionModel.shapeInteractionModel()) return;

    var constructor;
    switch (this.data.shape().constructor) {
        case cio_datamodel.RectangleData:
            constructor = editor_2d.RectangleInteractionView;
            break;
        case cio_datamodel.EllipseData:
            constructor = editor_2d.EllipseInteractionView;
            break;
        case cio_datamodel.TriangleData:
            constructor = editor_2d.TriangleInteractionView;
            break;
        case cio_datamodel.PathData:
            constructor = editor_2d.PathInteractionView;
            break;
        case cio_datamodel.LineData:
            constructor = editor_2d.LineInteractionView;
            break;
        case cio_datamodel.TextData:
            constructor = editor_2d.TextInteractionView;
            break;
        case cio_datamodel.PropertyData:
            constructor = PropertyInteractionView;
            break;
    }

    var layers = this.getLayers();
    if(!layers) return;


    var view = new constructor(this.editorView, this.interactionModel.shapeInteractionModel(), this.parentGroup, layers, null, this.getAttributes);
    this.shapeInteractionView = view;

    view.getMouseDownEvent = function () {
        var cEvent = new lib_core.GuiEvent(lib_core.GuiEvents.ELEMENT_MOUSE_DOWN)
            .fromJSEvent()
            .element( self.interactionModel )
            .data( 'mouseCoord', self.editorView.relativeMouseCoord() );
        return cEvent;
    };

    view.setSelected(this.interactionModel.shapeInteractionModel().selected());
};

ShapeWrapperInteractionView.prototype.removeSvg = function () {
    if(this.shapeInteractionView) this.shapeInteractionView.removeSvg();
};

ShapeWrapperInteractionView.prototype.getLayers = function () {
    throw new Error("getLayers function should be implemented by the inheriting interaction view")
};
